import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "text-center"
}

import ElCardSection from "~/cabinet/vue/interface/card/ElCardSection.vue";
import MyPagination from "~/cabinet/vue/interface/pagination/MyPagination.vue";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import {USE_REMOTE_DATA_EMITS, useRemoteData, useRemoteDataProps} from "~/cabinet/vue/interface/data/useRemoteData";
import MyRemoteDataInterface from "~/cabinet/vue/interface/data/MyRemoteDataInterface";
import {__} from "~/ts/library/Translate";
import ReactiveFilterableListRequest from "~/core-ui/ts/request/ReactiveFilterableListRequest";



const __default__ = {
    name: "MyRemoteDataCards",
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useRemoteDataProps<any, any, ReactiveFilterableListRequest<any>>()
},
  emits: ["update:items", "update:params", "load-start", "result", "update:result", "update:data", "load", "error", "items", "fetch-result"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {computedItems, request, fetchResult, reload, exposed, isLoading} = useRemoteData(props);

__expose<MyRemoteDataInterface>(exposed);

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_row, { class: "el-row-root" }, {
      default: _withCtx(() => [
        ((_unref(request) && _unref(request).isLoading) || _unref(isLoading))
          ? (_openBlock(), _createBlock(_component_el_col, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(MyLoader, {
                  big: "",
                  key: "my-loader"
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(computedItems).length ? 'transition-group' : 'div'), {
              key: 1,
              name: "flip-list",
              tag: "div",
              class: "el-col el-col-24"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(computedItems), (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item[_ctx.rowKey]
                  }, [
                    _renderSlot(_ctx.$slots, "default", {
                      item: item,
                      index: index,
                      first: index === 0,
                      last: index === _unref(computedItems).length - 1
                    })
                  ]))
                }), 128))
              ]),
              _: 3
            })),
        (_unref(fetchResult) || (_unref(props).items?.length === 0))
          ? (_openBlock(), _createBlock(_component_el_col, { key: 2 }, {
              default: _withCtx(() => [
                (_unref(computedItems).length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(fetchResult) && _unref(fetchResult).page != null)
                        ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(MyPagination, {
                                "fetch-result": _unref(fetchResult),
                                request: _unref(props).request,
                                onCurrentChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(reload)($event))),
                                onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(reload)(0, $event)))
                              }, null, 8, ["fetch-result", "request"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ], 64))
                  : (_openBlock(), _createBlock(_component_el_card, { key: 1 }, {
                      default: _withCtx(() => [
                        _createVNode(ElCardSection, null, {
                          default: _withCtx(() => [
                            (_ctx.$slots.empty)
                              ? _renderSlot(_ctx.$slots, "empty", { key: 0 })
                              : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(__)("Нет данных")), 1))
                          ]),
                          _: 3
                        })
                      ]),
                      _: 3
                    }))
              ]),
              _: 3
            }))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})